import { Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

/**
 * Label + value pair for transaction-detail panels. Used by DepositDetail
 * and DisbursementDetail. Layout: dimmed uppercase label on top, sm text
 * value below. Renders an em-dash placeholder when `children` is empty.
 */
export function DetailField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <Stack gap={2}>
      <Text c="dimmed" size="xs" tt="uppercase" fw={600}>
        {label}
      </Text>
      <Text size="sm">{children ?? '—'}</Text>
    </Stack>
  );
}
